// import React, { useState, useEffect } from "react";
// import tw from "tailwind-styled-components";
// import {
//   BoxContainer,
//   BoxTitle,
//   BoxHead,
//   Underline,
// } from "../../Components/Styles/PageStyles";
// import { useSelector } from "react-redux";
// import { useMutation } from "react-query";
// import axios from "axios";
// import Config from "../../Config";
// import Loading from "../../Components/Loading";
// import NotFoundModel from "../../Components/NotFoundModel";
// import moment from "moment";
// import AddFoodMenu from "../../Components/FoodMenu/AddFoodMenu";
// import { toast } from "react-toastify";
// import { SubmitBtn } from "../../Components/Styles/InputStyles";
// import ConfirmPublish from "../../Components/FoodMenu/ConfirmPublish";

// const FoodMenu = () => {
//   const user = useSelector((state) => state.UserReducer.user);
//   const [apiData, setApiData] = useState([]);
//   const [activeDay, setActiveDay] = useState(1);
//   const [key, setKey] = useState("");
//   const [isFoodMenu, setIsFoodMenu] = useState(false);
//   const [isPublishMenu, setIsPublishMenu] = useState(false);
//   const [selectedData, setSelectedData] = useState("");
//   const propertyList = useSelector((state) => state.PropertyReducer.property);
//   const property = useSelector(
//     (state) => state.SelectPropertyReducer.selectProperty
//   );

//   const query = `&propId=${property?.id}`;

//   const fetchFunction = async () => {
//     const response = await axios.get(
//       `${Config.apiUrl}/food/list/prop/menu?${query}`,
//       {
//         headers: {
//           authorization: "Bearer" + " " + user.token,
//           "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
//         },
//       }
//     );
//     return response.data;
//   };

//   const getSuccess = (res) => {
//     if (res.isSuccess === false) {
//       error = true;
//     } else {
//       setApiData(res?.data || []);
//       const today = new Date().getDay() || 7;
//       const hasToday = res?.data?.some((item) => item.dayOfWeek === today);
//       setActiveDay(hasToday ? today : 1);
//     }
//   };

//   const getError = (res) => {};

//   const {
//     isLoading: isLoading,
//     mutate: getListMutate,
//     error,
//     data,
//     isRefetching,
//   } = useMutation(fetchFunction, {
//     onSuccess: getSuccess,
//     onError: getError,
//   });

//   useEffect(() => {
//     const handler = setTimeout(() => {
//       getListMutate();
//     }, 500);

//     return () => {
//       clearTimeout(handler);
//     };
//   }, [property]);

//   const dayNames = {
//     1: "Monday",
//     2: "Tuesday",
//     3: "Wednesday",
//     4: "Thursday",
//     5: "Friday",
//     6: "Saturday",
//     7: "Sunday",
//   };

//   const getDayMenu = (day) => {
//     return apiData.find((item) => item.dayOfWeek === day);
//   };

//   const getAllDays = () => {
//     return Array.from({ length: 7 }, (_, i) => i + 1).map((day) => ({
//       dayOfWeek: day,
//       name: dayNames[day],
//       hasData: !!getDayMenu(day),
//     }));
//   };

//   //------- Add Menu -------
//   const addMenuFunction = async (values) => {
//     return await axios.post(`${Config.apiUrl}/food/add/day/menu`, values, {
//       headers: {
//         authorization: "Bearer" + " " + user.token,
//         "Content-Type": "application/json",
//       },
//     });
//   };

//   const onAddMenuSuccess = (data) => {
//     if (data?.data?.isSuccess === true) {
//       toast.success(data?.data?.msg || "Success");
//       setIsFoodMenu(false);
//       getListMutate();
//     } else {
//       toast.error(data?.data?.msg || "An Error Occured");
//     }
//   };

//   const onAddMenuError = (data) => {
//     toast.error(data?.response?.data?.msg || "An Error Occured");
//   };

//   const { isLoading: addMenuLoading, mutate: addMenuMutate } = useMutation(
//     addMenuFunction,
//     {
//       onSuccess: onAddMenuSuccess,
//       onError: onAddMenuError,
//     }
//   );

//   //------- Edit Menu -------
//   const editMenuFunction = async (values) => {
//     return await axios.post(`${Config.apiUrl}/food/edit/day/menu`, values, {
//       headers: {
//         authorization: "Bearer" + " " + user.token,
//         "Content-Type": "application/json",
//       },
//     });
//   };

//   const onEditMenuSuccess = (data) => {
//     if (data?.data?.isSuccess === true) {
//       toast.success(data?.data?.msg || "Success");
//       setIsFoodMenu(false);
//       getListMutate();
//     } else {
//       toast.error(data?.data?.msg || "An Error Occured");
//     }
//   };

//   const onEditMenuError = (data) => {
//     toast.error(data?.response?.data?.msg || "An Error Occured");
//   };

//   const { isLoading: editMenuLoading, mutate: editMenuMutate } = useMutation(
//     editMenuFunction,
//     {
//       onSuccess: onEditMenuSuccess,
//       onError: onEditMenuError,
//     }
//   );

//   //------- Replicate Menu -------
//   const replicateMenuFunction = async (values) => {
//     return await axios.post(
//       `${Config.apiUrl}/food/replicate/day/menu`,
//       values,
//       {
//         headers: {
//           authorization: "Bearer" + " " + user.token,
//           "Content-Type": "application/json",
//         },
//       }
//     );
//   };

//   const onReplicateMenuSuccess = (data) => {
//     if (data?.data?.isSuccess === true) {
//       toast.success(data?.data?.msg || "Success");
//       getListMutate();
//     } else {
//       toast.error(data?.data?.msg || "An Error Occured");
//     }
//   };

//   const onReplicateMenuError = (data) => {
//     toast.error(data?.response?.data?.msg || "An Error Occured");
//   };

//   const { isLoading: replicateMenuLoading, mutate: replicateMenuMutate } =
//     useMutation(replicateMenuFunction, {
//       onSuccess: onReplicateMenuSuccess,
//       onError: onReplicateMenuError,
//     });

//   const handleReplicateMenu = () => {
//     const currentMenu = getDayMenu(activeDay);
//     if (currentMenu) {
//       replicateMenuMutate({
//         propId: property.id,
//         dayOfWeek: currentMenu.dayOfWeek,
//         breakfast: currentMenu.breakfast || "",
//         breakfastTiming: currentMenu.breakfastTiming || "",
//         lunch: currentMenu.lunch || "",
//         lunchTiming: currentMenu.lunchTiming || "",
//         snacks: currentMenu.snack || "",
//         snacksTiming: currentMenu.snackTiming || "",
//         dinner: currentMenu.dinner || "",
//         dinnerTiming: currentMenu.dinnerTiming || "",
//       });
//     }
//   };

//   const handleClose = () => {
//     setIsFoodMenu(false);
//   };

//   const isDayWithMenu = (day) => {
//     return apiData.some((item) => item.dayOfWeek === day);
//   };

//   const { mutate: publishMenuMutate, isLoading: publishMenuLoading } =
//     useMutation(
//       async ({ propId, status }) => {
//         const publishQuery = `propId=${propId}&isFoodPublished=${status}`;

//         const response = await axios.get(
//           `${Config.apiUrl}/food/publish/menu?${publishQuery}`,
//           {
//             headers: {
//               authorization: "Bearer" + " " + user.token,
//               "Content-Type":
//                 "application/x-www-form-urlencoded; charset=UTF-8",
//             },
//           }
//         );
//         return response.data;
//       },
//       {
//         onSuccess: (res) => {
//           if (res.isSuccess === false) {
//             toast.error(res?.msg || "Operation failed");
//           } else {
//             toast.success(res?.msg || "Operation successful");
//             setIsPublishMenu(false);

//             getListMutate();
//           }
//         },
//         onError: (error) => {
//           toast.error(error?.response?.data?.msg || "An error occurred");
//         },
//       }
//     );

//   return (
//     <BoxContainer className="min-h-screen">
//       <BoxHead>
//         <BoxTitle className="!mb-0 whitespace-nowrap">
//           Food Menu
//           <Underline />
//         </BoxTitle>
//       </BoxHead>

//       <div
//         className={`${
//           isFoodMenu ? "flex" : "hidden"
//         } fixed inset-0 h-screen w-screen bg-black/30 backdrop-blur-sm transition-all duration-800 ease-in-out`}
//       />
//       <div
//         className={`${
//           isFoodMenu
//             ? "translate-x-0 opacity-100"
//             : "translate-x-full opacity-0"
//         } fixed h-screen right-0 top-0 transition-all duration-800 ease-in-out bg-white flex items-start md:rounded-l-2xl overflow-hidden md:w-1/2 w-full lg:w-1/3 justify-start z-50`}
//       >
//         {isFoodMenu && (
//           <AddFoodMenu
//             setIsFoodMenu={setIsFoodMenu}
//             setSelectedData={setSelectedData}
//             selectedData={selectedData}
//             addMenuLoading={addMenuLoading}
//             addMenuMutate={addMenuMutate}
//             editMenuLoading={editMenuLoading}
//             editMenuMutate={editMenuMutate}
//             handleClose={handleClose}
//             propId={property.id}
//           />
//         )}
//       </div>

//       {isPublishMenu && (
//         <ConfirmPublish
//           publishMenuMutate={publishMenuMutate}
//           publishMenuLoading={publishMenuLoading}
//           setIsPublishMenu={setIsPublishMenu}
//           selectedData={selectedData}
//           propId={property.id}
//           data={data}
//         />
//       )}

//       {error && !isLoading && <NotFoundModel />}
//       {(isLoading || isRefetching) && <Loading />}

//       {!isLoading && !error && data && (
//         <>
//           <DayTabsContainer>
//             {getAllDays().map((day) => (
//               <DayTab
//                 key={day.dayOfWeek}
//                 $active={activeDay === day.dayOfWeek}
//                 $hasData={day.hasData}
//                 onClick={() => setActiveDay(day.dayOfWeek)}
//               >
//                 {day.name}
//               </DayTab>
//             ))}
//           </DayTabsContainer>

//           <div className="p-4">
//             <div className="flex justify-between items-center mb-4">
//               <h2 className="text-lg font-semibold text-gray-800">
//                 {dayNames[activeDay]}'s Menu
//               </h2>

//               <div className="flex justify-between items-center gap-2">
//                 {apiData.length === 1 && isDayWithMenu(activeDay) && (
//                   <AddBtn
//                     className="border border-primary-color text-primary-color bg-transparent"
//                     type="button"
//                     onClick={handleReplicateMenu}
//                     disabled={replicateMenuLoading}
//                   >
//                     {replicateMenuLoading
//                       ? "Replicating..."
//                       : "Replicate on all days"}
//                   </AddBtn>
//                 )}
//                 {getDayMenu(activeDay) && (
//                   <AddBtn
//                     type="button"
//                     onClick={() => {
//                       setKey(moment().unix());
//                       setSelectedData(getDayMenu(activeDay));
//                       setIsFoodMenu(true);
//                     }}
//                   >
//                     Edit Menu
//                   </AddBtn>
//                 )}
//               </div>
//             </div>

//             {getDayMenu(activeDay) ? (
//               <div className="grid md:grid-cols-2 gap-6">
//                 <MealCard>
//                   <MealTitle>Breakfast</MealTitle>
//                   {getDayMenu(activeDay)?.breakfastTiming &&
//                   getDayMenu(activeDay)?.breakfast ? (
//                     <>
//                       <MealTime>
//                         {getDayMenu(activeDay)?.breakfastTiming}
//                       </MealTime>
//                       <MealItems>{getDayMenu(activeDay)?.breakfast}</MealItems>
//                     </>
//                   ) : (
//                     <div className="text-center py-4">
//                       <p className="text-gray-500 mb-4">
//                         You can add Breakfast after clicking edit menu button.
//                       </p>
//                     </div>
//                   )}
//                 </MealCard>

//                 <MealCard>
//                   <MealTitle>Lunch</MealTitle>
//                   {getDayMenu(activeDay)?.lunchTiming &&
//                   getDayMenu(activeDay)?.lunch ? (
//                     <>
//                       <MealTime>{getDayMenu(activeDay)?.lunchTiming}</MealTime>
//                       <MealItems>{getDayMenu(activeDay)?.lunch}</MealItems>
//                     </>
//                   ) : (
//                     <div className="text-center py-4">
//                       <p className="text-gray-500 mb-4">
//                         You can add Lunch after clicking edit menu button.
//                       </p>
//                     </div>
//                   )}
//                 </MealCard>

//                 <MealCard>
//                   <MealTitle>Snacks</MealTitle>
//                   {getDayMenu(activeDay)?.snackTiming &&
//                   getDayMenu(activeDay)?.snack ? (
//                     <>
//                       <MealTime>{getDayMenu(activeDay)?.snackTiming}</MealTime>
//                       <MealItems>{getDayMenu(activeDay)?.snack}</MealItems>
//                     </>
//                   ) : (
//                     <div className="text-center py-4">
//                       <p className="text-gray-500 mb-4">
//                         You can add Snacks after clicking edit menu button.
//                       </p>
//                     </div>
//                   )}
//                 </MealCard>

//                 <MealCard>
//                   <MealTitle>Dinner</MealTitle>
//                   {getDayMenu(activeDay)?.dinnerTiming &&
//                   getDayMenu(activeDay)?.dinner ? (
//                     <>
//                       <MealTime>{getDayMenu(activeDay)?.dinnerTiming}</MealTime>
//                       <MealItems>{getDayMenu(activeDay)?.dinner}</MealItems>
//                     </>
//                   ) : (
//                     <div className="text-center py-4">
//                       <p className="text-gray-500 mb-4">
//                         You can add Dinner after clicking edit menu button.
//                       </p>
//                     </div>
//                   )}
//                 </MealCard>
//               </div>
//             ) : (
//               <EmptyStateContainer>
//                 <EmptyStateText>
//                   No menu added for {dayNames[activeDay]}
//                 </EmptyStateText>
//                 <BtnWrapper>
//                   <AddBtn
//                     type="button"
//                     onClick={() => {
//                       setKey(moment().unix());
//                       setSelectedData({ dayOfWeek: activeDay });
//                       setIsFoodMenu(true);
//                     }}
//                     className="mt-4"
//                   >
//                     Add Menu
//                   </AddBtn>
//                 </BtnWrapper>
//               </EmptyStateContainer>
//             )}
//           </div>
//         </>
//       )}
//       {apiData.length !== 0 && isFoodMenu === false && (
//         <StickyFooter>
//           <SubmitBtn
//             type="button"
//             onClick={() => {
//               setIsPublishMenu(true);
//             }}
//           >
//             {data?.status === 1 ? "Unpublish" : "Publish"}
//           </SubmitBtn>
//         </StickyFooter>
//       )}
//     </BoxContainer>
//   );
// };

// // Styled components
// const DayTabsContainer = tw.div`flex overflow-x-auto pb-2 mb-3 scrollbar-hide`;
// const DayTab = tw.button`
//   px-4 py-2 mr-2 rounded-lg font-medium text-sm
//   ${(p) => {
//     if (p.$active) return "bg-blue-600 text-white";
//     if (p.$hasData) return "bg-indigo-300 text-white hover:bg-indigo-600";
//     return "bg-gray-100 text-gray-700 hover:bg-gray-200";
//   }}
//   transition-colors duration-200 whitespace-nowrap
// `;
// const MealCard = tw.div`bg-white rounded-lg shadow-sm p-4`;
// const MealTitle = tw.h3`text-lg font-semibold text-gray-800 mb-1`;
// const MealTime = tw.p`text-sm text-gray-500 mb-2`;
// const MealItems = tw.p`text-gray-700`;
// const AddBtn = tw.button`${(p) =>
//   p.$active
//     ? "bg-gray-100"
//     : ""} border whitespace-nowrap border-gray-200 flex space-x-1.5 justify-center items-center text-white h-full rounded-md px-6  cursor-pointer bg-primary-color hover:bg-hover-color  py-2.5 text-sm`;
// const EmptyStateContainer = tw.div`bg-white rounded-lg shadow-sm p-8 text-center`;
// const EmptyStateText = tw.p`text-gray-500 mb-1`;
// const BtnWrapper = tw.div`flex justify-center`;
// const StickyFooter = tw.div`fixed bottom-0 lg:left-56 left-0 right-0 bg-white border-t border-gray-200 px-6 py-4 flex justify-end z-10`;
// export default FoodMenu;

import React, { useState, useEffect } from "react";
import tw from "tailwind-styled-components";
import {
  BoxContainer,
  BoxTitle,
  BoxHead,
  Underline,
} from "../../Components/Styles/PageStyles";
import { useSelector } from "react-redux";
import { useMutation } from "react-query";
import axios from "axios";
import Config from "../../Config";
import Loading from "../../Components/Loading";
import NotFoundModel from "../../Components/NotFoundModel";
import moment from "moment";
import AddFoodMenu from "../../Components/FoodMenu/AddFoodMenu";
import { toast } from "react-toastify";
import { AddBtn, SubmitBtn } from "../../Components/Styles/InputStyles";
import ConfirmPublish from "../../Components/FoodMenu/ConfirmPublish";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";

const FoodMenu = () => {
  const user = useSelector((state) => state.UserReducer.user);
  const [apiData, setApiData] = useState([]);
  const [activeDay, setActiveDay] = useState(1);
  const [key, setKey] = useState("");
  const [isFoodMenu, setIsFoodMenu] = useState(false);
  const [isPublishMenu, setIsPublishMenu] = useState(false);
  const [selectedData, setSelectedData] = useState("");
  const propertyList = useSelector((state) => state.PropertyReducer.property);
  const property = useSelector(
    (state) => state.SelectPropertyReducer.selectProperty
  );
  const [selectedProperty, setSelectedProperty] = useState(property?.id || 0);

  const query = `&propId=${selectedProperty}`;

  const fetchFunction = async () => {
    // Don't call API if no property is selected
    if (selectedProperty === 0) {
      setApiData([]);
      return { isSuccess: false, data: [] };
    }

    const response = await axios.get(
      `${Config.apiUrl}/food/list/prop/menu?${query}`,
      {
        headers: {
          authorization: "Bearer" + " " + user.token,
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        },
      }
    );
    return response.data;
  };

  const getSuccess = (res) => {
    if (res.isSuccess === false) {
      error = true;
    } else {
      setApiData(res?.data || []);
      const today = new Date().getDay() || 7;
      const hasToday = res?.data?.some((item) => item.dayOfWeek === today);
      setActiveDay(hasToday ? today : 1);
    }
  };

  const getError = (res) => {};

  const {
    isLoading: isLoading,
    mutate: getListMutate,
    error,
    data,
    isRefetching,
  } = useMutation(fetchFunction, {
    onSuccess: getSuccess,
    onError: getError,
  });

  useEffect(() => {
    const handler = setTimeout(() => {
      getListMutate();
    }, 500);

    return () => {
      clearTimeout(handler);
    };
  }, [selectedProperty]);

  // const handlePropertyChange = (event) => {
  //   setSelectedProperty(event.target.value);
  // };
  const handlePropertyChange = (id) => {
    setSelectedProperty(id);
  };

  const dayNames = {
    1: "Monday",
    2: "Tuesday",
    3: "Wednesday",
    4: "Thursday",
    5: "Friday",
    6: "Saturday",
    7: "Sunday",
  };

  const getDayMenu = (day) => {
    return apiData.find((item) => item.dayOfWeek === day);
  };

  const getAllDays = () => {
    return Array.from({ length: 7 }, (_, i) => i + 1).map((day) => ({
      dayOfWeek: day,
      name: dayNames[day],
      hasData: !!getDayMenu(day),
    }));
  };

  //------- Add Menu -------
  const addMenuFunction = async (values) => {
    return await axios.post(`${Config.apiUrl}/food/add/day/menu`, values, {
      headers: {
        authorization: "Bearer" + " " + user.token,
        "Content-Type": "application/json",
      },
    });
  };

  const onAddMenuSuccess = (data) => {
    if (data?.data?.isSuccess === true) {
      toast.success(data?.data?.msg || "Success");
      setIsFoodMenu(false);
      getListMutate();
    } else {
      toast.error(data?.data?.msg || "An Error Occured");
    }
  };

  const onAddMenuError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: addMenuLoading, mutate: addMenuMutate } = useMutation(
    addMenuFunction,
    {
      onSuccess: onAddMenuSuccess,
      onError: onAddMenuError,
    }
  );

  //------- Edit Menu -------
  const editMenuFunction = async (values) => {
    return await axios.post(`${Config.apiUrl}/food/edit/day/menu`, values, {
      headers: {
        authorization: "Bearer" + " " + user.token,
        "Content-Type": "application/json",
      },
    });
  };

  const onEditMenuSuccess = (data) => {
    if (data?.data?.isSuccess === true) {
      toast.success(data?.data?.msg || "Success");
      setIsFoodMenu(false);
      getListMutate();
    } else {
      toast.error(data?.data?.msg || "An Error Occured");
    }
  };

  const onEditMenuError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: editMenuLoading, mutate: editMenuMutate } = useMutation(
    editMenuFunction,
    {
      onSuccess: onEditMenuSuccess,
      onError: onEditMenuError,
    }
  );

  //------- Replicate Menu -------
  const replicateMenuFunction = async (values) => {
    return await axios.post(
      `${Config.apiUrl}/food/replicate/day/menu`,
      values,
      {
        headers: {
          authorization: "Bearer" + " " + user.token,
          "Content-Type": "application/json",
        },
      }
    );
  };

  const onReplicateMenuSuccess = (data) => {
    if (data?.data?.isSuccess === true) {
      toast.success(data?.data?.msg || "Success");
      getListMutate();
    } else {
      toast.error(data?.data?.msg || "An Error Occured");
    }
  };

  const onReplicateMenuError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: replicateMenuLoading, mutate: replicateMenuMutate } =
    useMutation(replicateMenuFunction, {
      onSuccess: onReplicateMenuSuccess,
      onError: onReplicateMenuError,
    });

  const handleReplicateMenu = () => {
    const currentMenu = getDayMenu(activeDay);
    if (currentMenu) {
      replicateMenuMutate({
        propId: selectedProperty,
        dayOfWeek: currentMenu.dayOfWeek,
        breakfast: currentMenu.breakfast || "",
        breakfastTiming: currentMenu.breakfastTiming || "",
        lunch: currentMenu.lunch || "",
        lunchTiming: currentMenu.lunchTiming || "",
        snacks: currentMenu.snack || "",
        snacksTiming: currentMenu.snackTiming || "",
        dinner: currentMenu.dinner || "",
        dinnerTiming: currentMenu.dinnerTiming || "",
      });
    }
  };

  const handleClose = () => {
    setIsFoodMenu(false);
  };

  const isDayWithMenu = (day) => {
    return apiData.some((item) => item.dayOfWeek === day);
  };

  const { mutate: publishMenuMutate, isLoading: publishMenuLoading } =
    useMutation(
      async ({ propId, status }) => {
        const publishQuery = `propId=${propId}&isFoodPublished=${status}`;

        const response = await axios.get(
          `${Config.apiUrl}/food/publish/menu?${publishQuery}`,
          {
            headers: {
              authorization: "Bearer" + " " + user.token,
              "Content-Type":
                "application/x-www-form-urlencoded; charset=UTF-8",
            },
          }
        );
        return response.data;
      },
      {
        onSuccess: (res) => {
          if (res.isSuccess === false) {
            toast.error(res?.msg || "Operation failed");
          } else {
            toast.success(res?.msg || "Operation successful");
            setIsPublishMenu(false);

            getListMutate();
          }
        },
        onError: (error) => {
          toast.error(error?.response?.data?.msg || "An error occurred");
        },
      }
    );

  return (
    <BoxContainer className="min-h-screen">
      <BoxHead>
        <BoxTitle className="!mb-0 whitespace-nowrap">
          Food Menu
          <Underline />
        </BoxTitle>

        {/* Property Selector */}
        {/* <div className="ml-4">
          <Select
            value={selectedProperty}
            onChange={handlePropertyChange}
            displayEmpty
            size="small"
            sx={{ minWidth: 200 }}
            className="h-10"
          >
            {propertyList.map((prop) => (
              <MenuItem key={prop.id} value={prop.id}>
                {prop.name}
              </MenuItem>
            ))}
          </Select>
        </div> */}
      </BoxHead>

      <div
        className={`${
          isFoodMenu ? "flex" : "hidden"
        } fixed inset-0 h-screen w-screen bg-black/30 backdrop-blur-sm transition-all duration-800 ease-in-out`}
      />
      <div
        className={`${
          isFoodMenu
            ? "translate-x-0 opacity-100"
            : "translate-x-full opacity-0"
        } fixed h-screen right-0 top-0 transition-all duration-800 ease-in-out bg-white flex items-start md:rounded-l-2xl overflow-hidden md:w-1/2 w-full lg:w-1/3 justify-start z-50`}
      >
        {isFoodMenu && (
          <AddFoodMenu
            setIsFoodMenu={setIsFoodMenu}
            setSelectedData={setSelectedData}
            selectedData={selectedData}
            addMenuLoading={addMenuLoading}
            addMenuMutate={addMenuMutate}
            editMenuLoading={editMenuLoading}
            editMenuMutate={editMenuMutate}
            handleClose={handleClose}
            propId={selectedProperty}
          />
        )}
      </div>

      {isPublishMenu && (
        <ConfirmPublish
          publishMenuMutate={publishMenuMutate}
          publishMenuLoading={publishMenuLoading}
          setIsPublishMenu={setIsPublishMenu}
          selectedData={selectedData}
          propId={selectedProperty}
          data={data}
        />
      )}

      {error && !isLoading && selectedProperty !== 0 && <NotFoundModel />}
      {(isLoading || isRefetching) && <Loading />}

      {selectedProperty === 0 ? (
        <Shell>
          <Card>
            <Title>Choose a Property</Title>
            <Hint>
              Please select a single property to view its food menu. You cannot
              view the menu for all properties at once.
            </Hint>

            {/* Info before listing */}
            {!selectedProperty && (
              <div className="mt-3 rounded-lg border border-amber-200 bg-amber-50 p-3 text-sm text-amber-700">
                ℹ️ Select a property below to continue.
              </div>
            )}

            {/* Property listing */}
            <div className="mt-5 grid gap-4 sm:grid-cols-4">
              {propertyList
                .filter((prop) => prop.id !== 0) // exclude id=0
                .map((prop) => (
                  <div
                    key={prop.id}
                    onClick={() => handlePropertyChange(prop.id)}
                    className={`cursor-pointer rounded-xl border p-4 shadow-sm transition
              ${
                selectedProperty === prop.id
                  ? "border-indigo-500 bg-indigo-50 ring-2 ring-indigo-200"
                  : "border-gray-200 bg-white hover:border-indigo-300 hover:bg-gray-50"
              }
            `}
                  >
                    <p className="font-semibold text-gray-900">{prop.name}</p>
                    <p className="text-sm text-gray-500">Click to select</p>
                  </div>
                ))}
            </div>

            {selectedProperty && (
              <Helper>
                ✅ You have selected{" "}
                <span className="font-medium">
                  {propertyList.find((p) => p.id === selectedProperty)?.name}
                </span>
              </Helper>
            )}
          </Card>
        </Shell>
      ) : (
        !isLoading &&
        !error && (
          <>
            <DayTabsContainer>
              {getAllDays().map((day) => (
                <DayTab
                  key={day.dayOfWeek}
                  $active={activeDay === day.dayOfWeek}
                  $hasData={day.hasData}
                  onClick={() => setActiveDay(day.dayOfWeek)}
                >
                  {day.name}
                </DayTab>
              ))}
            </DayTabsContainer>

            <div className="p-4">
              <div className="flex justify-between items-center mb-4">
                <h2 className="text-lg font-semibold text-gray-800">
                  {dayNames[activeDay]}'s Menu
                </h2>

                <div className="flex justify-between items-center gap-2">
                  {apiData.length === 1 && isDayWithMenu(activeDay) && (
                    <AddBtn
                      className="border border-primary-color text-primary-color bg-transparent"
                      type="button"
                      onClick={handleReplicateMenu}
                      disabled={replicateMenuLoading}
                    >
                      {replicateMenuLoading
                        ? "Replicating..."
                        : "Replicate on all days"}
                    </AddBtn>
                  )}
                  {getDayMenu(activeDay) && (
                    <AddBtn
                      type="button"
                      onClick={() => {
                        setKey(moment().unix());
                        setSelectedData(getDayMenu(activeDay));
                        setIsFoodMenu(true);
                      }}
                    >
                      Edit Menu
                    </AddBtn>
                  )}
                </div>
              </div>

              {getDayMenu(activeDay) ? (
                <div className="grid md:grid-cols-2 gap-6">
                  <MealCard>
                    <MealTitle>Breakfast</MealTitle>
                    {getDayMenu(activeDay)?.breakfastTiming &&
                    getDayMenu(activeDay)?.breakfast ? (
                      <>
                        <MealTime>
                          {getDayMenu(activeDay)?.breakfastTiming}
                        </MealTime>
                        <MealItems>
                          {getDayMenu(activeDay)?.breakfast}
                        </MealItems>
                      </>
                    ) : (
                      <div className="text-center py-4">
                        <p className="text-gray-500 mb-4">
                          You can add Breakfast after clicking edit menu button.
                        </p>
                      </div>
                    )}
                  </MealCard>

                  <MealCard>
                    <MealTitle>Lunch</MealTitle>
                    {getDayMenu(activeDay)?.lunchTiming &&
                    getDayMenu(activeDay)?.lunch ? (
                      <>
                        <MealTime>
                          {getDayMenu(activeDay)?.lunchTiming}
                        </MealTime>
                        <MealItems>{getDayMenu(activeDay)?.lunch}</MealItems>
                      </>
                    ) : (
                      <div className="text-center py-4">
                        <p className="text-gray-500 mb-4">
                          You can add Lunch after clicking edit menu button.
                        </p>
                      </div>
                    )}
                  </MealCard>

                  <MealCard>
                    <MealTitle>Snacks</MealTitle>
                    {getDayMenu(activeDay)?.snackTiming &&
                    getDayMenu(activeDay)?.snack ? (
                      <>
                        <MealTime>
                          {getDayMenu(activeDay)?.snackTiming}
                        </MealTime>
                        <MealItems>{getDayMenu(activeDay)?.snack}</MealItems>
                      </>
                    ) : (
                      <div className="text-center py-4">
                        <p className="text-gray-500 mb-4">
                          You can add Snacks after clicking edit menu button.
                        </p>
                      </div>
                    )}
                  </MealCard>

                  <MealCard>
                    <MealTitle>Dinner</MealTitle>
                    {getDayMenu(activeDay)?.dinnerTiming &&
                    getDayMenu(activeDay)?.dinner ? (
                      <>
                        <MealTime>
                          {getDayMenu(activeDay)?.dinnerTiming}
                        </MealTime>
                        <MealItems>{getDayMenu(activeDay)?.dinner}</MealItems>
                      </>
                    ) : (
                      <div className="text-center py-4">
                        <p className="text-gray-500 mb-4">
                          You can add Dinner after clicking edit menu button.
                        </p>
                      </div>
                    )}
                  </MealCard>
                </div>
              ) : (
                <EmptyStateContainer>
                  <EmptyStateText>
                    No menu added for {dayNames[activeDay]}
                  </EmptyStateText>
                  <BtnWrapper>
                    <AddBtn
                      type="button"
                      onClick={() => {
                        setKey(moment().unix());
                        setSelectedData({ dayOfWeek: activeDay });
                        setIsFoodMenu(true);
                      }}
                      className="mt-4"
                    >
                      Add Menu
                    </AddBtn>
                  </BtnWrapper>
                </EmptyStateContainer>
              )}
            </div>
          </>
        )
      )}
      {selectedProperty !== 0 &&
        apiData.length !== 0 &&
        isFoodMenu === false && (
          <StickyFooter>
            <SubmitBtn
              type="button"
              onClick={() => {
                setIsPublishMenu(true);
              }}
            >
              {data?.status === 1 ? "Unpublish" : "Publish"}
            </SubmitBtn>
          </StickyFooter>
        )}
    </BoxContainer>
  );
};

// Styled components
const DayTabsContainer = tw.div`flex overflow-x-auto pb-2 mb-3 scrollbar-hide`;
const DayTab = tw.button`
  px-4 py-2 mr-2 rounded-lg font-medium text-sm
  ${(p) => {
    if (p.$active) return "bg-blue-600 text-white";
    if (p.$hasData) return "bg-indigo-300 text-white hover:bg-indigo-600";
    return "bg-gray-100 text-gray-700 hover:bg-gray-200";
  }}
  transition-colors duration-200 whitespace-nowrap
`;
const MealCard = tw.div`bg-white rounded-lg shadow-sm p-4`;
const MealTitle = tw.h3`text-lg font-semibold text-gray-800 mb-1`;
const MealTime = tw.p`text-sm text-gray-500 mb-2`;
const MealItems = tw.p`text-gray-700`;
const EmptyStateContainer = tw.div`bg-white rounded-lg shadow-sm p-8 text-center`;
const EmptyStateText = tw.p`text-gray-500 mb-1`;
const BtnWrapper = tw.div`flex justify-center`;
const StickyFooter = tw.div`fixed bottom-0 lg:left-56 left-0 right-0 bg-white border-t border-gray-200 px-6 py-4 flex justify-end z-10`;

const Shell = tw.div`
  min-h-[40vh] grid place-items-center py-4 bg-gradient-to-b from-gray-50 to-white
`;

const Card = tw.div`
  w-full  rounded-2xl border border-gray-200 bg-white shadow-sm p-6
`;

const Title = tw.h2`
  text-lg font-semibold text-gray-900
`;

const Hint = tw.p`
  mt-1 text-sm text-gray-500
`;

const Helper = tw.p`
  mt-2 text-xs text-gray-400
`;
export default FoodMenu;
